<template>
  <FormSelect
    label="Campaign Type"
    :values="values"
    :options="options"
    :rules="rules"
    :loading="loading"
    :disabled="loading"
    :multiple="multiple"
    :emit-value="!rawData"
    :rawData="rawData"
    @updateStore="onUpdateStore"
  />
</template>

<script>
import { ref, computed, watch, onBeforeMount } from 'vue'
import { FormSelect } from '@/components/inputs'
import { VALIDATION, Toast, fetchData } from '@/tools'

export default {
  name: 'SelectCampaignType',
  inheritAttrs: true,
  emits: ['updateStore', 'getOptions'],
  components: {
    FormSelect
  },
  props: {
    values: {
      type: [String, Number, Array, Object],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    withAll: {
      type: Boolean,
      default: false
    },
    rawData: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { data, error, loading, get } = fetchData()
    const { showToast } = Toast()
    const options = ref([])
    const rules = computed(() => {
      return props.multiple ? [VALIDATION.requiredArray] : [VALIDATION.required]
    })

    const onUpdateStore = data => {
      emit('updateStore', data)
    }

    onBeforeMount(() => {
      get('v1/campaign-types')

      watch([data, error, loading], () => {
        if (!loading.value) {
          if (error?.value) {
            showToast('There was a problem fetching campaign types.', 'danger')
          } else if (data?.value) {
            options.value = data?.value
              ?.filter(item => item?.status === 'A')
              ?.map(item => ({
                label: item?.name,
                value: item?.id
              }))

            if (props.withAll) {
              options.value.unshift({
                label: 'All',
                value: 'all'
              })
            }

            emit('getOptions', options.value)
          }
        }
      })
    })

    return { options, rules, loading, VALIDATION, onUpdateStore }
  }
}
</script>
